<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-dedication element-without-heading" id="dedication">
<div class="text" id="dedication-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center dedication-content">For my son Matt, for his total dedication to Doris,</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">and to all my Kat and Mouse fans</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">who have loved the five books in this series.</p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?3f6ee10c